import { render, staticRenderFns } from "./StatisticsDetails.vue?vue&type=template&id=4a4b4e36&scoped=true"
import script from "./StatisticsDetails.vue?vue&type=script&lang=js"
export * from "./StatisticsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4b4e36",
  null
  
)

export default component.exports